export const ACTIVATE_CONTEXT = 'ACTIVATE_CONTEXT'
export const ADD_DOCUMENT = 'ADD_DOCUMENT'
export const BLUR_EDITOR = 'BLUR_EDITOR'
export const DEACTIVATE_CONTEXT = 'DEACTIVATE_CONTEXT'
export const DISCARD_DOCUMENT = 'DISCARD_DOCUMENT'
export const DUPLICATE_DOCUMENT = 'DUPLICATE_DOCUMENT'
export const DOCUMENTS_LOADED = 'DOCUMENTS_LOADED'
export const EDIT_DOCUMENT = 'EDIT_DOCUMENT'
export const FOCUS_EDITOR = 'FOCUS_EDITOR'
export const LOAD_DOCUMENT = 'LOAD_DOCUMENT'
export const LOAD_DOCUMENTS = 'LOAD_DOCUMENTS'
export const MERGE_DOCUMENT = 'MERGE_DOCUMENT'
export const MERGE_DOCUMENTS = 'MERGE_DOCUMENTS'
export const RESTORE_DOCUMENT = 'RESTORE_DOCUMENT'
export const RESTRICT_DOCUMENT = 'RESTRICT_DOCUMENT'
export const SET_CONTEXT_TAGS = 'SET_CONTEXT_TAGS'
export const SET_DOCUMENT = 'SET_DOCUMENT'
export const SET_EDITOR = 'SET_EDITOR'
export const SET_OFFLINE = 'SET_OFFLINE'
export const SET_ONLINE = 'SET_ONLINE'
export const SET_RIGHT_SIDEBAR_VISIBILITY = 'SET_RIGHT_SIDEBAR_VISIBILITY'
export const SET_SHOW_WELCOME = 'SET_SHOW_WELCOME'
export const SHARE_DOCUMENT = 'SHARE_DOCUMENT'
export const SIGN_OUT = 'SIGN_OUT'
export const SYNC = 'SYNC'
export const TOUCH_DOCUMENT = 'TOUCH_DOCUMENT'

export default {
  ACTIVATE_CONTEXT,
  ADD_DOCUMENT,
  BLUR_EDITOR,
  DEACTIVATE_CONTEXT,
  DISCARD_DOCUMENT,
  DUPLICATE_DOCUMENT,
  DOCUMENTS_LOADED,
  EDIT_DOCUMENT,
  FOCUS_EDITOR,
  LOAD_DOCUMENT,
  LOAD_DOCUMENTS,
  MERGE_DOCUMENT,
  MERGE_DOCUMENTS,
  RESTORE_DOCUMENT,
  RESTRICT_DOCUMENT,
  SET_CONTEXT_TAGS,
  SET_DOCUMENT,
  SET_EDITOR,
  SET_OFFLINE,
  SET_ONLINE,
  SET_RIGHT_SIDEBAR_VISIBILITY,
  SET_SHOW_WELCOME,
  SHARE_DOCUMENT,
  SIGN_OUT,
  SYNC,
  TOUCH_DOCUMENT,
}
